module.exports = __webpack_public_path__ + "img/photo-06.359260fb.jpg";